import { useCallback, useMemo } from 'react';

import { ACTIONS } from '~/services/toasts/internalServerError';

import { testsApi } from '../../tests.api';
import { showGroupError } from '../../tests.utils';
import { usePlaybackCursorPosition } from '../usePlaybackCursorPosition/usePlaybackCursorPosition';

export const useCreateGroup = () => {
  const [createGroup, createGroupState] = testsApi.useCreateGroupMutation();
  const { refreshPlaybackCursorPosition } = usePlaybackCursorPosition();

  const handleCreateGroup = useCallback(
    async (params: Parameters<typeof createGroup>[0]) => {
      const result = createGroup(params).unwrap();

      result
        .then(() => {
          refreshPlaybackCursorPosition();
        })
        .catch((error) => {
          showGroupError(ACTIONS.CREATE, error);
        });

      return result;
    },
    [createGroup, refreshPlaybackCursorPosition],
  );

  return useMemo(
    () => [handleCreateGroup, createGroupState] as const,
    [handleCreateGroup, createGroupState],
  );
};
